<div *ngIf="visibleComponent === 'LIST'">

    <div class="table-container">
      <table>
        <thead>
          <tr>
            <th>Events</th>
            <th class="center" *ngIf="canAddEvent"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let evt of eventList">
            <td (click)="navigateToEvent(evt)">
              {{ evt.eventName }}
            </td>
            <td class="center" *ngIf="canAddEvent">
              <img
                src="../../../assets/noun-pencil-8209025-FFFFFF.png"
                class="pencil"
                (click)="editEvent(evt); $event.stopPropagation()"
              />
            </td>
          </tr>
        </tbody>
        </table>
    </div>

    <div id="admin-controls" *ngIf="canAddEvent">
        <button (click)="switchVisibleComponent('CREATE')">Add Event</button>
    </div>
</div>



<div *ngIf="visibleComponent === 'CREATE'">
    <app-create-event (saved)="refreshEventList()" (canceled)="switchVisibleComponent('LIST')"></app-create-event>
</div>

<div *ngIf="visibleComponent === 'EDIT'">
    <app-edit-event [league]="eventToEdit" (saved)="refreshEventList()" (canceled)="switchVisibleComponent('LIST')"></app-edit-event>
</div>
